var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-h6 ml-4 title-overflow"},[_vm._v(" "+_vm._s(_vm.title)+" "),_c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [(_vm.tooltip)?_c('v-icon',_vm._g(_vm._b({},'v-icon',attrs,false),on),[_vm._v("mdi-help-circle-outline")]):_vm._e()]}}])},[_c('span',[_vm._v(_vm._s(_vm.tooltip))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }